import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AddCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AddCircleSVG;
